import { Link } from 'react-router-dom';
import collectionsData from '../data/collections.json';
import { Icon, Ornament } from '../components/Primitives';
import Seo from '../components/Seo';

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page not found"
        description="That page could not be found. Browse the collections or visit our showroom on C G Road, Ahmedabad."
      />

      <section className="noise-navy relative flex min-h-[70svh] items-center overflow-hidden">
        <img
          src="/assets/logo/monogram-white.png"
          alt=""
          aria-hidden="true"
          className="pointer-events-none absolute left-1/2 top-1/2 w-[30rem] -translate-x-1/2 -translate-y-1/2 opacity-[0.05]"
        />

        <div className="shell relative py-20 text-center">
          <p className="eyebrow-light">Error 404</p>
          <h1 className="display-xl mt-5 text-cream-50">This piece is not in the case</h1>
          <Ornament tone="light" className="mt-7" />
          <p className="mx-auto mt-7 max-w-xl text-[15px] leading-relaxed text-cream-200/75 sm:text-base">
            The page you were looking for has moved or never existed. Everything we
            hold is a click away below.
          </p>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            <Link to="/" className="btn-gold">
              Back to home
              <Icon.Arrow className="h-3.5 w-3.5" />
            </Link>
            <Link to="/collections" className="btn-outline-light">
              Browse collections
            </Link>
          </div>

          <div className="mx-auto mt-14 max-w-3xl border-t border-cream-50/10 pt-8">
            <p className="eyebrow-light">Or jump to</p>
            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
              {collectionsData.collections.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/collections/${c.slug}`}
                    className="link-underline text-[14px] text-cream-200/75 hover:text-gold-300"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
